module.exports = "<simple-notifications [options]=\"notifyOptions\"></simple-notifications>\n{{metricvalue}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/metric/metric.component.html
// module id = ./src/app/shared/components/widgets/metric/metric.component.html
// module chunks = main